import { useCallback } from "react";
import { useUser } from "./use-user";
import { StringHelper } from "../helper";
import flattenDeep from "lodash/flattenDeep";
import { IAPItem } from "./use-steps";

interface IRequest {
  eApprovalProcess: IAPItem[][];
  eCreatedBy: string;
}

export const useRequests = () => {
  const { checkCurrentUser, isHighPriority } = useUser();

  const getRequests = useCallback(
    (requests: any[], highPriorityUsers: string[]) => {
      if (!requests) return [];
      return requests.filter((item: IRequest) => {
        const eApprovalProcess = flattenDeep(item.eApprovalProcess);
        if (isHighPriority(highPriorityUsers)) return true;
        return eApprovalProcess.some(
          (e, index) => checkCurrentUser(e.email) && index !== 0
        );
      });
    },
    [checkCurrentUser, isHighPriority]
  );

  const getMyRequests = useCallback(
    (requests: any[]) => {
      if (!requests) return [];
      return requests.filter(({ eCreatedBy }: IRequest) => {
        const email = StringHelper.verticalBarSplit<string[]>(eCreatedBy)[0];
        return checkCurrentUser(email);
      });
    },
    [checkCurrentUser]
  );

  return { getRequests, getMyRequests };
};
